module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_PLAFOND_KNAUF_ORGANIC_GRIS_PIERRE_HAUTEUR_2300.b7d44e91.png";